/**
 * Project Store
 *
 * Convenience re-export from organization-store for project-related state.
 * This provides a cleaner API for components that only need project context.
 */

import { useOrganizationStore } from './organization-store'

/**
 * Hook to access project-related state from the organization store.
 * Provides selectedProject (alias for currentProject) and projects list.
 */
export const useProjectStore = <T>(
  selector: (state: {
    selectedProject: ReturnType<typeof useOrganizationStore.getState>['currentProject']
    projects: ReturnType<typeof useOrganizationStore.getState>['projects']
    setSelectedProject: ReturnType<typeof useOrganizationStore.getState>['setCurrentProject']
  }) => T
) => {
  return useOrganizationStore((state) =>
    selector({
      selectedProject: state.currentProject,
      projects: state.projects,
      setSelectedProject: state.setCurrentProject,
    })
  )
}
